import { graphql, useStaticQuery } from 'gatsby'

export const useCalStyleConfig = () => {
  const {
    classic,
    shadowBox,
    classicBlack,
    classicWhite,
    classicSage,
    classicLagoon,
    shadowBoxSilver,
    shadowBoxCharcoal,
    individualClassicBlack,
    individualShadowBoxSilver,
    contentfulFrame2Price,
  } = useStaticQuery(graphql`
    query CalendarStyleConfigImages {
      classic: file(relativePath: { eq: "cal-pdp/white-icon.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      shadowBox: file(relativePath: { eq: "cal-pdp/charcoal-icon.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      classicBlack: file(relativePath: { eq: "cal-pdp/black-icon.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      classicWhite: file(relativePath: { eq: "cal-pdp/white-icon.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      classicSage: file(relativePath: { eq: "cal-pdp/sage-icon.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      classicLagoon: file(relativePath: { eq: "cal-pdp/lagoon-icon.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      shadowBoxSilver: file(relativePath: { eq: "cal-pdp/silver-icon.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      shadowBoxCharcoal: file(relativePath: { eq: "cal-pdp/charcoal-icon.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      individualClassicBlack: file(
        relativePath: { eq: "frame2/style/individual-classic-black.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      individualShadowBoxSilver: file(
        relativePath: { eq: "frame2/style/individual-shadow-box-aluminum.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      contentfulFrame2Price: allContentfulFrame2AndSnapFrameStrikethrough {
        edges {
          node {
            classic_black_original_price
            classic_black_discounted_price
            classic_black_discount_bubble
            classic_white_original_price
            classic_white_discounted_price
            classic_white_discount_bubble
            classic_sage_original_price
            classic_sage_discounted_price
            classic_sage_discount_bubble
            classic_lagoon_original_price
            classic_lagoon_discounted_price
            classic_lagoon_discount_bubble
            shadow_box_aluminum_original_price
            shadow_box_aluminum_discounted_price
            shadow_box_aluminum_discount_bubble
            shadow_box_charcoal_original_price
            shadow_box_charcoal_discounted_price
            shadow_box_charcoal_discount_bubble
            snap_classic_black_original_price
            snap_classic_black_discounted_price
            snap_classic_white_original_price
            snap_classic_white_discounted_price
            snap_classic_sage_original_price
            snap_classic_sage_discounted_price
            snap_classic_lagoon_original_price
            snap_classic_lagoon_discounted_price
            snap_shadow_box_aluminum_original_price
            snap_shadow_box_aluminum_discounted_price
            snap_shadow_box_charcoal_original_price
            snap_shadow_box_charcoal_discounted_price
          }
        }
      }
    }
  `)
  const prices = contentfulFrame2Price.edges[0].node
  const styleConfig = {
    Classic: {
      image: {
        White: classicWhite,
        Black: classicBlack,
        Sage: classicSage,
        Lagoon: classicLagoon,
      },
      snapImage: {
        White: classic,
        Black: classic,
        Sage: classic,
        Lagoon: classic,
      },
      snapFrameIndividualImage: {
        Black: individualClassicBlack,
      },
      prices: {
        White: {
          originalPrice: 299.99,
          discountedPrice: 'NONE',
          discountBubble: 'NONE',
        },
        Black: {
          originalPrice: 299.99,
          discountedPrice: 'NONE',
          discountBubble: 'NONE',
        },
        Sage: {
          originalPrice: 299.99,
          discountedPrice: 'NONE',
          discountBubble: 'NONE',
        },
        Lagoon: {
          originalPrice: 299.99,
          discountedPrice: 'NONE',
          discountBubble: 'NONE',
        },
      },
      snapPrices: {
        Black: {
          originalPrice: prices.snap_classic_black_original_price,
          discountedPrice: prices.snap_classic_black_discounted_price,
        },
        White: {
          originalPrice: prices.snap_classic_white_original_price,
          discountedPrice: prices.snap_classic_white_discounted_price,
        },
        Sage: {
          originalPrice: prices.snap_classic_sage_original_price,
          discountedPrice: prices.snap_classic_sage_discounted_price,
        },
        Lagoon: {
          originalPrice: prices.snap_classic_lagoon_original_price,
          discountedPrice: prices.snap_classic_lagoon_discounted_price,
        },
      },
      defaultPrices: {
        originalPrice: 299.99,
        discountedPrice: 'NONE',
        discountBubble: 'NONE',
      },
      snapDefaultPrices: {
        originalPrice: prices.snap_classic_black_original_price,
        discountedPrice: prices.snap_classic_black_discounted_price,
      },
      description: 'Elegant & versatile.',
      basePrice: 299.99,
      snapBasePrice: 14.99,
    },
    'Shadow Box': {
      image: {
        Charcoal: shadowBoxCharcoal,
        Silver: shadowBoxSilver,
      },
      snapImage: {
        Charcoal: shadowBox,
        Silver: shadowBox,
      },
      snapFrameIndividualImage: {
        Silver: individualShadowBoxSilver,
      },
      prices: {
        Charcoal: {
          originalPrice: 319.99,
          discountedPrice: 'NONE',
          discountBubble: 'NONE',
        },
        Silver: {
          originalPrice: 319.99,
          discountedPrice: 'NONE',
          discountBubble: 'NONE',
        },
      },
      snapPrices: {
        Charcoal: {
          originalPrice: prices.snap_shadow_box_charcoal_original_price,
          discountedPrice: prices.snap_shadow_box_charcoal_discounted_price,
        },
        Silver: {
          originalPrice: prices.snap_shadow_box_aluminum_original_price,
          discountedPrice: prices.snap_shadow_box_aluminum_discounted_price,
        },
      },
      defaultPrices: {
        originalPrice: 319.99,
        discountedPrice: 'NONE',
        discountBubble: 'NONE',
      },
      snapDefaultPrices: {
        originalPrice: prices.snap_shadow_box_aluminum_original_price,
        discountedPrice: prices.snap_shadow_box_aluminum_discounted_price,
      },
      description: 'Sleek & modern aluminum.',
      basePrice: 319.99,
      snapBasePrice: 29.99,
      snapPromo: 'Free',
    },
  }

  return styleConfig
}

export const CAL_2_STYLE_OOS = {
  Classic: {
    White: false,
    Black: false,
    Sage: true,
    Lagoon: true,
  },
  'Shadow Box': {
    Charcoal: false,
    Silver: false,
  },
}

export const FRAME_2_STYLE_OOS = {
  Classic: {
    White: false,
    Black: false,
    Sage: false,
    Lagoon: false,
  },
  'Shadow Box': {
    Charcoal: false,
    Silver: false,
  },
  Cover: {
    Black: false,
    White: false,
  },
  Wood: {
    Walnut: false,
    Birch: false,
  },
}
